import { Drawer, Spin, Form, Checkbox, Button, Select, Row, Col, Input, InputNumber } from 'antd';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import useEnrollmentUpdate from '../../../../../../../hooks/useEnrollmentUpdate';
import useMobileBreakpoint from '../../../../../../../hooks/useMobileBreakpoint';
import SelectWithRequest from '../../../../../../../components/common/inputs/SelectWithRequest';

const DrawerInstitutionalProfile = ({
  visible,
  closeDrawer,
  title,
  form,
  qualifiedInvestor,
  setSavedQualifiedInvestor,
  showValidationMessages,
}) => {
  const [updateEnrollment, isLoading] = useEnrollmentUpdate();
  const [country, setCountry] = useState('');
  const [region, setRegion] = useState('');

  const onCountryChange = (newCountry) => {
    setCountry(newCountry);

    setRegion(undefined);
  };

  const onRegionChange = (newRegion) => {
    setRegion(newRegion);
  };

  useEffect(() => {
    if (showValidationMessages) {
      form.validateFields().then().catch();
    }
  }, [showValidationMessages]);

  const isMobile = useMobileBreakpoint();

  const handleSubmit = async ({ qualifiedInvestorDeclaration }) => {
    const updatePayload = {
      qualifiedInvestorDeclaration,
      enrollmentInvestorProfile: {
        isQualifiedInvestor: true,
      },
    };

    updateEnrollment(updatePayload);
    setSavedQualifiedInvestor(true);
    closeDrawer();
  };

  return (
    <Drawer
      title="Declaración de Inversionista Calificado"
      width={isMobile ? null : 720}
      onClose={() => {
        closeDrawer();
      }}
      visible={visible}
      bodyStyle={{ paddingBottom: 80 }}
    >
      <Spin spinning={isLoading}>
        <p className="drawerInstitutional__title">{title}</p>
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          <p>
            El cliente firmante cuyos datos se individualizan en el cuerpo del Contrato al cual
            accede el presente Anexo, declara que Sí es un inversionista calificado.
          </p>
          <p>
            El Suscrito, en su calidad de Inversionista Calificado de acuerdo a lo establecido en el
            numeral 8. de la sección ll de la Norma de Carácter General Nº 216 de 2008 impartida por
            la Comisión para el Mercado Financiero, bajo juramento viene en declarar su intención
            expresa de participar e invertir en el mercado financiero a través de instrumentos con
            condiciones y requisitos específicos, entre los cuales se encuentran a título meramente
            ejemplar y enunciativo, valores de oferta pública de emisores nacionales y/o
            extranjeros, cuotas o series de cuotas de fondos mutuos y/o de inversión, dirigidos a
            Inversionistas Calificados, acciones o participaciones de vehículos de inversión
            colectiva extranjeros, contratos de derivados celebrados en Chile o en el extranjero con
            el propósito de cubrir el riesgo de fluctuaciones de tasas, precios y tipos de cambio de
            los activos administrados, contratos sobre productos agropecuarios que se transen en
            bolsas de productos nacionales, facturas que sean adquiridas en centros bursátiles
            nacionales que cuenten con autorización para transar este tipo de activos, notas
            estructuradas; contrato de préstamo de valores y cualesquiera otro instrumento
            financiero que pudiera desarrollarse en el futuro.
          </p>

          <p>
            Asismismo, el(la) Suscrito(a) declara expresamente que entiende a cabalidad y acepta
            todos los riesgos propios de los mercados especiales y sus instrumentos, y que cumple
            con los requisitos establecidos en la NCG Nº216 para ser considerado como Inversionista
            Calificado.
          </p>
          <p>
            A mayor abundamiento, y a fin de precisar lo previamente referido, el(la) Suscrito(a)
            declara ser:
          </p>

          <Row gutter={24}>
            <Col span={12}>
              <Form.Item
                required={qualifiedInvestor}
                name={['qualifiedInvestorDeclaration', 'personType']}
              >
                <Select required={qualifiedInvestor}>
                  <Select.Option value="LEGAL_FOREIGN">
                    Persona jurídica o entidad extranjera
                  </Select.Option>
                  <Select.Option value="LEGAL">Persona jurídica o entidad chilena</Select.Option>
                  <Select.Option value="NATURAL">Persona Natural</Select.Option>
                  <Select.Option value="NATURAL_FOREIGN">Persona Natural extrajera</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <p>Con domicilio en:</p>

          <Row gutter={24}>
            <Col lg={12} xs={24}>
              <Form.Item
                required={qualifiedInvestor}
                label="País"
                name={['qualifiedInvestorDeclaration', 'address', 'country']}
                rules={[
                  {
                    required: true,
                    message: 'Dato requerido',
                  },
                ]}
              >
                <SelectWithRequest
                  url="/params/countries"
                  onChange={onCountryChange}
                  autoComplete="none"
                />
              </Form.Item>
            </Col>
            {country === 'CHILE' && (
              <>
                <Col lg={12} xs={24}>
                  <Form.Item
                    label="Región"
                    required={qualifiedInvestor}
                    name={['qualifiedInvestorDeclaration', 'address', 'region']}
                    rules={[
                      {
                        required: true,
                        message: 'Dato requerido',
                      },
                    ]}
                  >
                    <SelectWithRequest
                      url={`/params/regions?country=${country}`}
                      onChange={onRegionChange}
                      autoComplete="none"
                    />
                  </Form.Item>
                </Col>
                <Col lg={12} xs={24}>
                  <Form.Item
                    label="Comuna"
                    required={qualifiedInvestor}
                    name={['qualifiedInvestorDeclaration', 'address', 'city']}
                    rules={[
                      {
                        required: true,
                        message: 'Dato requerido',
                      },
                    ]}
                  >
                    <SelectWithRequest
                      url={`/params/cities?region=${region}`}
                      autoComplete="none"
                    />
                  </Form.Item>
                </Col>
              </>
            )}

            <Col span={12}>
              <Form.Item
                label="Calle/Avenida"
                required={qualifiedInvestor}
                name={['qualifiedInvestorDeclaration', 'address', 'streetName']}
                rules={[
                  {
                    required: true,
                    message: 'Dato requerido',
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label="Número"
                required={qualifiedInvestor}
                name={['qualifiedInvestorDeclaration', 'address', 'streetNumber']}
                rules={[
                  {
                    required: true,
                    message: 'Dato requerido',
                  },
                ]}
              >
                <InputNumber style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label="Depto/Casa"
                name={['qualifiedInvestorDeclaration', 'address', 'houseNumber']}
                rules={[{ required: false }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            name={['qualifiedInvestorDeclaration', 'isInstitutionalInvestor']}
            valuePropName="checked"
          >
            <Checkbox>
              Que es un inversionista institucional, entendido por tales aquellos contenidos en la
              letra e) del artículo 4 bis de la Ley Nº 18.045.
            </Checkbox>
          </Form.Item>
          <Form.Item
            name={['qualifiedInvestorDeclaration', 'isRegularizedEntity']}
            valuePropName="checked"
          >
            <Checkbox>
              Que es una entidad regulada en carácter de empresa bancaria, compañía de seguro,
              entidad de reaseguro, administradora de fondos o intermediario de valores, constituida
              en el extranjero. En este último caso, cuando actúe por cuenta propia o por cuenta de
              terceros que no sean ciudadanos, residentes o transeúntes.
            </Checkbox>
          </Form.Item>
          <Form.Item name={['qualifiedInvestorDeclaration', 'isBroker']} valuePropName="checked">
            <Checkbox>
              Que es un corredor de bolsa o agente de valores actuando por cuenta propia
            </Checkbox>
          </Form.Item>
          <Form.Item
            name={['qualifiedInvestorDeclaration', 'isAgriculturalProductsBroker']}
            valuePropName="checked"
          >
            <Checkbox>
              Que es un corredor de bolsa de productos agropecuarios, actuando por cuenta propia y
              la inversión corresponde a productos de aquellos señalados en el artículo N°5 de la
              Ley N° 19.220
            </Checkbox>
          </Form.Item>

          <Form.Item
            name={['qualifiedInvestorDeclaration', 'hasPublicOfferableInvestmentsLessThan10000']}
            valuePropName="checked"
          >
            <Checkbox>
              Que es una persona natural o jurídica o una entidad chilena o extranjera, que al
              momento de efectuar la inversión cuenta con inversiones financieras en valores
              susceptibles de ser ofrecidos públicamente en Chile o en el extranjero, por un monto
              no inferior a 10.000 UF
            </Checkbox>
          </Form.Item>
          <Form.Item
            name={['qualifiedInvestorDeclaration', 'investmentDecisionsDelegatedToNcg216']}
            valuePropName="checked"
          >
            <Checkbox>
              Que es una persona natural o jurídica o una entidad chilena o extranjera, que ha
              delegado las decisiones de inversión en un Inversionista Calificado de acuerdo a las
              consideraciones de la NCG Nº216, en virtud de un contrato de administración de
              cartera. Esto, en la medida que la facultad para participar en los mercados
              especiales, ofertas y colocaciones a que se refiere la NCG Nº216 haya quedado
              expresamente señalada en el contrato de administración respectivo y que el
              Inversionista Calificado hubiere informado al suscrito las operaciones realizadas en
              virtud de dicha facultad, con la periodiciodad establecida en dicho contrato
            </Checkbox>
          </Form.Item>
          <Form.Item
            name={['qualifiedInvestorDeclaration', 'investmentDecisionsAdoptedByNcg216']}
            valuePropName="checked"
          >
            <Checkbox>
              Que es una persona jurídica o entidad, chilena o extranjera, en que las decisiones de
              inversión son adoptadas por un Inversionista Calificado de acuerdo a las
              consideraciones de la NCG Nº216.
            </Checkbox>
          </Form.Item>
          <Form.Item
            name={['qualifiedInvestorDeclaration', 'hasPublicOfferableInvestmentsGreaterThan2000']}
            valuePropName="checked"
          >
            <Checkbox>
              Que es una persona o entidad, chilena o extranjera, que a esta fecha cuenta con
              inversiones financieras en valores susceptibles de ser ofrecidos públicamente en Chile
              o en el extranjero, por un monto igual o superior a UF 2.000 y que, adicionalmente,
              cumple con al menos uno de los siguientes requisitos:
            </Checkbox>
          </Form.Item>

          <Form.Item
            name={['qualifiedInvestorDeclaration', 'hasAssetsGreaterThan100000']}
            valuePropName="checked"
            style={{ marginLeft: '22px' }}
          >
            <Checkbox>
              Cuenta con activos iguales o superiores a UF 100.000.
              <br />
              Ha realizado transacciones en el mercado de valores por un monto individual igual o
              superior a UF 1.000 y con una frecuencia mínima de 20 operaciones trimestrales,
              durante los últimos 4 trimestres.
            </Checkbox>
          </Form.Item>
          <Form.Item
            name={['qualifiedInvestorDeclaration', 'hasStockMarketRiskKnowledge']}
            valuePropName="checked"
            style={{ marginLeft: '24px' }}
          >
            <Checkbox>
              Cuenta con el conocimiento necesario para entender los riesgos que conlleva participar
              en mercados, colocaciones u ofertas con requisitos, condiciones, parámetros y riesgos
              distintos a los propios del mercado general de valores.
            </Checkbox>
          </Form.Item>

          <p style={{ marginLeft: '48px' }}>
            <strong>Conocimientos adquiridos como consecuencia de:</strong>
          </p>
          <Form.Item
            style={{ marginLeft: '48px' }}
            name={['qualifiedInvestorDeclaration', 'hasRelatedFormation']}
            valuePropName="checked"
          >
            <Checkbox>
              Haber cursado una carrera profesional o haber realizado estudios posteriores a ella
              relacionados con el área de negocios o inversiones.
            </Checkbox>
          </Form.Item>
          <Form.Item
            style={{ marginLeft: '48px' }}
            name={['qualifiedInvestorDeclaration', 'hasMadeRelatedWorkForAtLeastTwoYears']}
            valuePropName="checked"
          >
            <Checkbox>
              Haber desempeñado, por a lo menos dos años consecutivos, un cargo profesional que
              requiere de tal conocimiento para su ejercicio, tales como mesas de dinero,
              departamentos dedicados a realizar análisis financiero, asesorías financieras,
              administración y gestión de recursos vinculados a desiciones de inversión de un
              inversionista Calificado, asesorías jurídicas en materias de inversiones u otras áreas
              o funciones afines.
            </Checkbox>
          </Form.Item>

          <p>
            Declara que finalmente el(la) Suscrito(a), que ha sido detalladamente informado por
            Grupo Vantrust Capital S.A acerca de las características y riesgos particulares de los
            mercados e instrumentos objeto de inversión y, en particular, lo siguiente:
          </p>

          <ol>
            <li>
              Que los valores y sus emisores puedes contar con requisitos, parámetros y riesgos
              diferentes a aquellos correspondientes al mercado general de valores, razón por la que
              sólo pueden participar Inversionistas Calificados.
            </li>
            <li>
              Que la Comisión para el Mercado financiero, en consideración a las características de
              determinados emisores de valores, al volumen de sus operaciones u otras
              circunstancias, está legalmente facultada para requerirles menor información y
              circunscribir la transacción de sus valores a los grupos de inversionistas que
              determine.
            </li>
            <li>
              Que en virtud de lo anterior, la Comisión para el Mercado Financiero, a través de
              Normas de Carácter General, ha establecido menores requisitos de información para
              aquellos emisores que pretendan hacer oferta de sus valores en mercado especiales o
              dirigirlas exclusivamente a Inversionistas Calificados.
            </li>
            <li>
              Que, tratándose de valores extranjeros, la información legal, económica y financiera
              corresponderá a aquella que el emisor entrega en sus mercados de origen o en otros
              mercados donde los valores se negocian, y que la oferta pública de valores extranjeros
              en Chile requiere de parte de la Comisión para el Mercado Financiero únicamente de la
              inscricpión en el Registro de Valores Extranjeros que lleva al efecto, por lo cual
              sólo le compete la regulación y supervisión de la oferta pública que de dichos títulos
              se haga en Chile, con las limitaciones que conlleva que los emisores respectivos
              tengan domicilio en el extranjero.
            </li>
          </ol>

          <p>
            La presente declaración se suscribe en duplicado, entregándose en este mismo acto un
            ejemplar firmado de la misma al inversionista, mientras que el otro permanecerá en las
            oficinas de Grupo Vantrust Capital S.A
          </p>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              Confirmar
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </Drawer>
  );
};

DrawerInstitutionalProfile.propTypes = {
  visible: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  closeDrawer: PropTypes.func.isRequired,
  form: PropTypes.objectOf.isRequired,
  qualifiedInvestor: PropTypes.bool.isRequired,
  setSavedQualifiedInvestor: PropTypes.func.isRequired,
  showValidationMessages: PropTypes.bool.isRequired,
};

export default DrawerInstitutionalProfile;
